import 'angular:locale/data:fr';
import 'angular:locale/data:nl';
import 'angular:locale/data:en';
import './src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
